<template>
  <default-modal ref="box" @cancel="cancel" :title="title" :modalWidth="1200" class="editorCon"
    :confirmTxt="confirmText" @confirm="confirm">
    <div class="modal-body f14 pr">
      <div>
        <div class="row">
          <span class="left">规则名称：</span>
          <input type="text" v-model="ruleName" placeholder="长度最多128个字符，支持中英文" />
        </div>
        <div class="row">
          <span class="left">规则介绍：</span>
          <input type="text" v-model="ruleIntroduction" placeholder="长度最多128个字符，支持中英文" />
        </div>
        <div class="row">
          <span class="left"></span>
          <newEditorCom @addRule="addRule" ref="editorFn" />
        </div>
        <div class="row">
          <span class="left">规则内容：</span>
          <textarea class="editTextArea scrollStyle" warp="off" cols="" rows="" v-model="ruleText"></textarea>
        </div>
        <!-- <div class="row">
          <span class="left"></span>
          <editorRule />
        </div> -->
        <div class="row clearfix" v-if="$store.state.user.isCanUseClient">
          <span class="left">是否共享：</span>
          <switchc :value="isShare" @change="change" class="fl"></switchc>
          <!-- <div class="fl redCol" style="margin:4px 0 0 10px;">
            *用户之间共享策略! 请勿随意共享规则，违者作封号处理！
          </div> -->
        </div>
        <div class="row clearfix" v-if="$store.state.user.isCanUseClient">
          <span class="left">适用系统：</span>
          <ul class="clearfix fl">
            <li class="fl" style="line-height:30px;margin-right:20px;">
              <input type="checkbox" class="fl f12" :checked="isCheckWin7" @change="isCheckWin7 = !isCheckWin7"
                style="width:20px;margin-right:4px;margin-top:8px;">
              <label for="win10">
                Win7
              </label>
            </li>
            <li class="fl" style="line-height:30px;margin-right:20px;">
              <input type="checkbox" class="fl f12" :checked="isCheckWin10" @change="isCheckWin10 = !isCheckWin10"
                style="width:20px;margin-right:4px;margin-top:8px;">
              <label for="win10">
                Win10
              </label>
            </li>
          </ul>
        </div>

        <div class="tips">
          <!-- <a href="https://123.weihudashi.com/878/" target="_blank">规则语法说明</a> -->
          <!-- <a href="http://www.clxp.net.cn/thread-14662-1-1.html" target="_blank">规则生成器</a> -->
        </div>
      </div>
    </div>
    <div class="row pa" style="margin-left: 25px; bottom: 30px;">
      <span>版本：</span>
      <span v-text="version"></span>
      <span> | </span>
      <span>最后更新：</span>
      <span v-text="endTime"></span>
    </div>
  </default-modal>
</template>
<script>
import { Base64 } from 'js-base64'
import { showDate } from '@/utils/time'
import DefaultModal from '_c/modals/defaultModal'
import { editRule, getRuleText, addRuleShare, getLogPageById } from '@/requests/securityCenter'
import switchc from '_c/switch/switch'
import editorRule from '@/components/relue/editor.vue'
import newEditorCom from '@/components/relue/newEditor.vue'
export default {
  components: {
    DefaultModal,
    switchc,
    editorRule,
    newEditorCom
  },
  data () {
    return {
      ruleId: '',
      ruleName: '',
      ruleText: '',
      ruleIntroduction: '',
      version: 1,
      endTime: '',
      title: '',
      confirmText: '',
      successFn: '',
      isShare: false,
      isCheckWin7: true,
      isCheckWin10: true,
      oldRule: ''
    }
  },
  mounted () {
    if (!!window.ActiveXObject || 'ActiveXObject' in window) {
      /* eslint-disable */
      console.log("yes");
    } else
    {
      console.log(document.getElementsByClassName(
        "editTextArea"
      ))
      // if (document.getElementsByClassName(
      //   "editTextArea"
      // ) != undefined)
      // {
      //   document.getElementsByClassName(
      //     "editTextArea"
      //   )[0].style.whiteSpace = "nowrap";
      //   document.getElementsByClassName("editTextArea")[0].style.overflow =
      //     "auto";
      // }

    }
    window.$modal.editRulesModal = {};
    window.$modal.editRulesModal.show = (
      id,
      ruleName,
      ruleIntroduction,
      version,
      modifyTime
    ) => {
      if (id !== undefined)
      {
        this.title = "修改规则";
        this.ruleId = id;
        this.ruleName = ruleName;
        this.confirmText = "保存";
        this.ruleIntroduction = ruleIntroduction;
        this.version = version;
        this.endTime = modifyTime.replace("T", " ");
        this.getRuleText();
        //this.getLogPageById()
      } else
      {
        this.title = "新建规则";
        this.ruleId = "";
        this.ruleName = "";
        this.confirmText = "添加";
        this.ruleIntroduction = "";
        this.version = 1;
        this.endTime = showDate("Y-M-D h:m:s", new Date());
        this.ruleText = "";
      }
      return new Promise((resolve) => {
        this.init(() => {
          resolve(true);
        });
      });
    };
  },
  methods: {
    cancel () {
      this.$refs.editorFn.resetFn()
    },
    addRule (val) {
      let arr = val.split("\n")
      let txt = false
      arr.forEach(el => {
        let rule = this.ruleText.split("\n")
        let index = rule.findIndex(val => val == el)
        if (index == -1)
        {
          this.ruleText = el + '\n' + this.ruleText
        } else
        {
          if (rule[index].indexOf('//') == 0)
          {
            this.ruleText = el + '\n' + this.ruleText
          } else 
          {
            if (el != '')
            {
              txt = true
            }
          }
        }
      })
      if (txt)
      {
        this.$Notice.warning({
          desc: "添加失败，当前规则已经存在。"
        });
      }
    },
    async getLogPageById () {
      let res = await getLogPageById({
        id: '',
        ruleId: this.ruleId,
        ruleVersion: '',
        checkType: '',
        shareTime: '',
        checkTime: '',
        current: 1,
        size: 10
      })
      if (res.code == 200)
      {
        if (res.data.total > 0)
        {
          this.isShare = true
        }
      }
    },
    change (e) {
      this.isShare = e
    },
    // 初始化信息
    init (fn) {
      this.$refs.box.show();
      this.successFn = fn;
      this.isShare = false
      this.isCheckWin7 = true
      this.isCheckWin10 = true
    },
    async getRuleText () {
      let res = await getRuleText({
        id: this.ruleId,
      });
      // Base64.decode
      if (res.code == 200)
      {
        let fitOs = []
        this.isCheckWin10 = false
        this.isCheckWin7 = false
        this.ruleText = res.data.ruleContent;
        this.oldRule = res.data.ruleContent
        this.isShare = res.data.isShare
        if (res.data.fitOs != undefined)
        {
          fitOs = res.data.fitOs.split(",")
          fitOs.forEach(el => {
            if (el == '10.0')
            {
              this.isCheckWin10 = true
            }
            if (el == '6.1')
            {
              this.isCheckWin7 = true
            }
          })
        }
      }
    },
    async confirm () {
      let vdt, baseText;
      baseText = Base64.encode(this.ruleText).replace(/\+/g, "%2B");
      vdt = this.$validateCenter.ruleName(this.ruleName);
      if (!vdt.res)
      {
        return this.$refs.box.setWrong(vdt.msg);
      }
      if (this.ruleIntroduction.length > 128)
      {
        return this.$refs.box.setWrong("规则介绍长度不可超过128个字符");
      }
      if (!this.ruleText)
      {
        return this.$refs.box.setWrong("请输入规则内容");
      }
      const bolb = new Blob([this.ruleText],{type:"text/plain"})
      const sizeInBytes = bolb.size
      const sizeInkb = sizeInBytes/1024
      if(sizeInkb >64){
        return this.$refs.box.setWrong("规则内容长度不能大于64KB");
      }
      let fitOs = ''
      if (this.isCheckWin7 == true)
      {
        if (fitOs != '')
        {
          fitOs = fitOs + ',' + '6.1'
        } else
        {
          fitOs = '6.1'
        }
      }
      if (this.isCheckWin10 == true)
      {
        if (fitOs != '')
        {
          fitOs = fitOs + ',' + '10.0'
        } else
        {
          fitOs = '10.0'
        }
      }
      let resValue = await editRule({
        id: this.ruleId,
        ruleName: this.ruleName,
        ruleIntroduction: this.ruleIntroduction,
        ruleContent: baseText,
        isShare: Number(this.isShare),
        fitOs: fitOs
      });
      if (resValue.code == 200)
      {
        this.$refs.box.hide();
        this.successFn();
        if (this.ruleId == '')
        {
          this.ruleId = resValue.data.id
        }
        // if (this.isShare)
        // {
        //   let resShare = await addRuleShare({
        //     ruleId: this.ruleId
        //   })
        //   if (resValue.code != 200)
        //   {
        //     this.$refs.box.setWrong(resValue.msg);
        //   }
        // }
      } else
      {
        this.$refs.box.setWrong(resValue.msg);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-body {
  padding: 10px 20px;
  text-align: left;
  position: relative;
  // max-height: 700px;
  // overflow-y: auto;

  .row {
    overflow: hidden;
    margin: 10px 0;

    .left {
      float: left;
      margin-right: 10px;
      min-width: 85px;
      display: inline-block;
      text-align: right;
      height: 30px;
      line-height: 30px;
    }
  }

  input {
    width: calc(100% - 100px);
    border: 1px solid #DCDFE6;
    font-size: 12px;
    color: #515151;
    text-align: left;
    padding-left: 10px;
    border-radius: 4px;
    line-height: 30px;
  }

  textarea {
    padding: 9px;
    width: 1060px;
    height: 200px;
    // white-space: nowrap;
    // overflow: auto;
    border: 1px solid rgba(215, 215, 215, 1);
    font-family: serif;
    font-size: 13px !important;
  }

  .tips {
    position: absolute;
    bottom: -62px;
    left: 35px;

    a {
      text-decoration: underline;
      margin-right: 10px;
    }
  }
}

.editTextArea {
  width: 1060px;
}
</style>

<style lang="scss">
.editorCon {
  .wrong {
    margin-left: 600px !important;
  }
}
</style>